import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useDeleteCovenant() {
  const [isDeleting, setDeleting] = useState(false);

  const remove = useCallback((covenantId) => {
    setDeleting(true);
    return quarkusApi
      .delete(`/covenant-catalog/${covenantId}`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setDeleting(false));
  }, []);

  return { remove, isDeleting };
}
